import _ from 'lodash'
export default {
  linksLabels (state) {
    let result = {}
    Object.keys(state.links).forEach((linkId) => {
      let numbers = []
      state.links[linkId].sources.forEach((sourceId) => {
        numbers.push(state.sources[sourceId].orderIndex)
      })
      result[linkId] = '[' + numbers.join(', ') + ']'
    })
    return result
  },
  orderedSources (state) {
    let result = []
    Object.keys(state.sources).forEach((sourceId) => {
      const content = state.sources[sourceId]
      result.push({
        id: sourceId,
        index: content.orderIndex,
        label: `[${content.orderIndex}]`,
        content
      })
    })
    return _.sortBy(result, s => s.index)
  }
}


// WEBPACK FOOTER //
// ./src/vuex/getters.js